import { Environment } from '~/shared/types/environment'

export const setDebugEnvVars = () => {
  if (globalThis.window?.['ENV']?.env !== Environment.PROD && globalThis.window?.['ENV']?.env !== Environment.ON_PREM) {
    globalThis.window['ENV']['flags'] = {
      ...(typeof globalThis.window['ENV']['flags'] === 'object' ? globalThis.window['ENV']['flags'] : {}),
      toggleDebugMenu: () => {
        // note: we can't use the local storage hook here because it causes SSR issues
        localStorage.setItem('portal.showDebugMenu', JSON.stringify(!JSON.parse(localStorage.getItem('portal.showDebugMenu') || 'false')))
        location.reload()
      }
    }
  }
}
